import React from "react";
import { useDashTheme } from "../hooks/useDashTheme";

// Controls that live inside a DataTable row.
//
// CountPill is a count that is also the way in: it reads as a number at rest and
// gains a border on hover so it's discoverable as a control. Unlike IconBtn it
// stays visible at rest, because the number itself is information.
export function CountPill({ icon, value, loading, muted, title, onClick }) {
  const t = useDashTheme();
  const [hover, setHover] = React.useState(false);
  const empty = value == null || muted;
  const label = loading && value == null ? "…" : value == null ? "—" : value;

  return (
    <button
      type="button"
      title={title}
      onClick={(e) => { e.stopPropagation(); onClick(); }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: "inline-flex", alignItems: "center", gap: 5, height: 26, padding: "0 8px",
        borderRadius: 7, cursor: "pointer",
        border: `1px solid ${hover ? t.c.border : "transparent"}`,
        background: hover ? t.c.surfaceMuted : "transparent",
        color: hover ? t.c.text : empty ? t.c.textTertiary : t.c.textSecondary,
        fontSize: t.font.size.sm, fontFamily: t.font.family,
        fontVariantNumeric: "tabular-nums", transition: "background 120ms, color 120ms, border-color 120ms",
      }}
    >
      <span style={{ display: "inline-flex", color: hover ? t.c.primary : t.c.icon }}>{icon}</span>
      <span style={{ fontWeight: empty ? 400 : 600 }}>{label}</span>
    </button>
  );
}

// Square ghost icon button for row action clusters. Wrap a group in
// `className="tg-row-actions"` to reveal them on row hover only.
export function IconBtn({ children, onClick, title, danger, disabled }) {
  const t = useDashTheme();
  const base = danger ? t.status.negative : t.c.textTertiary;
  return (
    <button
      onClick={(e) => { e.stopPropagation(); if (!disabled) onClick(); }}
      title={title}
      disabled={disabled}
      style={{
        width: 30, height: 30, display: "inline-flex", alignItems: "center", justifyContent: "center",
        borderRadius: 7, border: "none", background: "transparent", color: base,
        cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.45 : 1,
        transition: "background 120ms, color 120ms",
      }}
      onMouseEnter={(e) => {
        if (disabled) return;
        e.currentTarget.style.background = danger ? t.status.negativeSoft : t.c.surfaceMuted;
        e.currentTarget.style.color = danger ? t.status.negative : t.c.text;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "transparent";
        e.currentTarget.style.color = base;
      }}
    >
      {children}
    </button>
  );
}
